"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDomainAdvantagesTemplate = exports.getDomainAchievementsTemplate = void 0;
const lit_html_1 = require("lit-html");
/**
 * Возвращает шаблон преимуществ и недостатков домена
 */
function getDomainAchievementsTemplate(achievements, translations) {
    if (!achievements) {
        return;
    }
    if (!achievements.advantages.length) {
        return null;
    }
    return (0, lit_html_1.html) `
        <div class="domain-insights">
            <ul class="domain-insights-list domain-insights-list--advantages" data-list-header="${translations.instant('advantages')}">
                ${achievements.advantages.map((advantage) => (0, lit_html_1.html) `
                    <li>${advantage}</li>
                `)}
            </ul>
            ${achievements.disadvantages.length ? (0, lit_html_1.html) `
                <ul class="domain-insights-list domain-insights-list--considerations" data-list-header="${translations.instant('consideration')}">
                    ${achievements.disadvantages.map((disadvantage) => (0, lit_html_1.html) `
                        <li>${disadvantage}</li>
                    `)}
                </ul>
            ` : null}
        </div>
    `;
}
exports.getDomainAchievementsTemplate = getDomainAchievementsTemplate;
/**
 *
 */
function getDomainAdvantagesTemplate(advantages, translations, url) {
    if (!advantages || (advantages && advantages.length === 0))
        return '';
    return (0, lit_html_1.html) `
        <span class="domain__advantages">
            <button class="btn-close"></button>
            <div class="domain__advantages_list">
                <ul>
                    ${advantages.map((advantage) => (0, lit_html_1.html) `
                        <li>${advantage}</li>
                    `)}
                </ul>
            </div>
            <div class="js-read-more hidden">
                <a class="link" href="${url}">${translations.instant('readMore')}</a>
            </div>
        </span>
    `;
}
exports.getDomainAdvantagesTemplate = getDomainAdvantagesTemplate;
